var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "container-m" },
    [
      _c("page-title", {
        staticClass: "page-title",
        attrs: { title: "Gewählter Kunde" }
      }),
      _vm._v(" "),
      _c("v-divider", { staticClass: "divider" }),
      _vm._v(" "),
      _vm.isCoCustomer
        ? _c(
            "v-expansion-panel",
            {
              staticClass: "expansion-panel",
              attrs: { expand: "" },
              model: {
                value: _vm.panelCustomerInfo,
                callback: function($$v) {
                  _vm.panelCustomerInfo = $$v
                },
                expression: "panelCustomerInfo"
              }
            },
            _vm._l(_vm.dropdownTitlesCustomerInfo, function(item, i) {
              return _c(
                "v-expansion-panel-content",
                {
                  key: i,
                  attrs: { id: "expansion-panel" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "actions",
                        fn: function() {
                          return [
                            _c("v-icon", { staticClass: "icon-expand" }, [
                              _vm._v("$vuetify.icons.expand")
                            ])
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "header",
                        fn: function() {
                          return [_c("div", [_vm._v(_vm._s(item))])]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    true
                  )
                },
                [
                  _vm._v(" "),
                  _vm._v(" "),
                  i === 0
                    ? _c("customer-selected-information", {
                        attrs: {
                          addressInfo:
                            _vm.selectedCustomerVm.customer.anspAdressInfo,
                          customerLocked:
                            _vm.selectedCustomerVm.customer.locked,
                          isCoCustomer: _vm.isCoCustomer,
                          updatesAuthorized: _vm.getUpdateText(
                            _vm.selectedCustomerVm.customer.updateBerechtigt
                          ),
                          prepaidSupportHours:
                            _vm.selectedCustomerVm.customer.prepaidSupportHours,
                          osaRegistrationMsg: _vm.osaRegistrationMsg,
                          spentSupportHours:
                            _vm.selectedCustomerVm.customer.spentSupportHours,
                          customerPmtId: _vm.selectedCustomerVm.customer.id
                        }
                      })
                    : i === 1
                    ? _c("customer-selected-information", {
                        attrs: {
                          addressInfo:
                            _vm.selectedCustomerVm.coCustomer.anspAdressInfo,
                          customerLocked:
                            _vm.selectedCustomerVm.coCustomer.locked,
                          updatesAuthorized: _vm.getUpdateText(
                            _vm.selectedCustomerVm.coCustomer.updateBerechtigt
                          ),
                          prepaidSupportHours:
                            _vm.selectedCustomerVm.coCustomer
                              .prepaidSupportHours,
                          osaRegistrationMsg: _vm.osaRegistrationMsg,
                          spentSupportHours:
                            _vm.selectedCustomerVm.coCustomer.spentSupportHours,
                          customerPmtId: _vm.selectedCustomerVm.coCustomer.id
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            }),
            1
          )
        : _c("customer-selected-information", {
            attrs: {
              addressInfo: _vm.selectedCustomerVm.customer.anspAdressInfo,
              customerLocked: _vm.selectedCustomerVm.customer.locked,
              updatesAuthorized: _vm.getUpdateText(
                _vm.selectedCustomerVm.customer.updateBerechtigt
              ),
              debitorennummer: _vm.selectedCustomerVm.customer.id,
              kundengruppe: _vm.selectedCustomerVm.customer.kundengruppe,
              osaRegistrationMsg: _vm.osaRegistrationMsg,
              siteKundennummer:
                _vm.selectedCustomerVm.customer.siteKundennummer,
              produktlinien: _vm.selectedCustomerVm.customer.produktlinien
            }
          }),
      _vm._v(" "),
      _c("v-divider", { attrs: { id: "end-divider" } }),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs12: "", md12: "" } },
        [
          _vm.kindOfSupport.showComboSupport
            ? _c("v-combobox", {
                staticClass: "customer-label-color-combo",
                attrs: {
                  items: _vm.kindOfSupport.values,
                  label: "Art der Supportanfrage."
                },
                on: { change: _vm.changeKindSupport },
                model: {
                  value: _vm.kindOfSupport.supportSelected,
                  callback: function($$v) {
                    _vm.$set(_vm.kindOfSupport, "supportSelected", $$v)
                  },
                  expression: "kindOfSupport.supportSelected"
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.notSupportRequestMsg.visible
        ? _c("div", { attrs: { id: "notSupportRequest" } }, [
            _vm._v("\n    " + _vm._s(_vm.notSupportRequestMsg.text) + "\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-expansion-panel",
        {
          staticClass: "expansion-panel",
          attrs: { focusable: "", expand: "" },
          model: {
            value: _vm.panel,
            callback: function($$v) {
              _vm.panel = $$v
            },
            expression: "panel"
          }
        },
        _vm._l(_vm.dropdownTitles, function(item, i) {
          return _c(
            "v-expansion-panel-content",
            {
              key: i,
              attrs: { id: "expansion-panel" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "actions",
                    fn: function() {
                      return [
                        _c("v-icon", { staticClass: "icon-expand" }, [
                          _vm._v("$vuetify.icons.expand")
                        ])
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "header",
                    fn: function() {
                      return [_c("div", [_vm._v(_vm._s(item))])]
                    },
                    proxy: true
                  }
                ],
                null,
                true
              )
            },
            [
              _vm._v(" "),
              _vm._v(" "),
              i === 0
                ? _c("open-cases-table", {
                    attrs: {
                      "case-data": _vm.selectedCustomerVm.customer.openedCases
                    },
                    on: {
                      expandAttendanceOpenCase: _vm.expandAttendanceOpenCase
                    }
                  })
                : i === 1
                ? _c("close-cases-table", {
                    attrs: {
                      "case-data": _vm.selectedCustomerVm.customer.closedCases
                    },
                    on: {
                      expandAttendanceCloseCase: _vm.expandAttendanceCloseCase
                    }
                  })
                : _vm._e()
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }